<template>
  <section class="task-wrap" :style="dBHeight">
    <div class="tab_ty1">
      <AuditTab :currentTab="5" />
      <div class="tab-content">
        <div>
          <div class="tab_ty2">
            <AuditSubTab :currentTab="5" :currentTab2="1" />
            <div class="tab-content">
             
              <div>
                <!-- 활동 현황 (메뉴 별) -->
                <div class="tb-list_ty1 audit001">
                  <div class="tb-header clear">
                    <div class="btnDiv fr">                      
                      <button
                        type="button"
                        class="btn-primary-small"
                        @click="getExcelDownload('objectStat', null)"
                      >엑셀 다운로드
                      </button>
                    </div>
                    <div class="search_ty2 fr">
                      <div class="calendar_box_grp small">
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="startDate"
                            :disabled-dates="startDisabledDate"
                          ></datepicker>
                        </div>
                        <span>~</span>
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="endDate"
                            :disabled-dates="endDisabledDate"
                          ></datepicker>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="tb-header clear">
                    <div class="tb_num fl" style="line-height: 0;">
                      <div class="num">총 건수 {{ totalCnt }}</div>
                    </div>
                  </div>

                  <div class="tb-header clear">
                    <div class="tb_num fl" :class="(sharUse === 'true' && cfrcUse === 'true') ? 'useAll' : (sharUse !== 'true' && cfrcUse !== 'true') ? 'notUse' : 'partialUse'" style="width: 100%;">
                      <div class="num" v-for="column in columnsInfo" :key="column.cdValue" 
                        v-show="column.use === 1"
                        @click="getExcelDownload(column.cdKey + '_ALL', sum)"
                      >
                        {{ column.cdKey === "PRO_CREATE" ? workspace : column.cdKey === "TODO_RECEIVE" ? todo : column.codeDesc }}: {{ sum != null && sum[column.cdKey] != null ? sum[column.cdKey] : 0 }} 건
                      </div>
                    </div>
                  </div>

                  <div class="tb-header clear">
                    <div class="tb_num fl" style="width: 100%;font-size: 12px;">
                      * 전일 기준으로 최대 90일까지 조회 가능합니다. 
                    </div>
                  </div>
                  <!-- //tb-header -->

                  <v-data-table
                    :headers="headers"
                    :items="objStatList"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :items-per-page="paging.perSize"
                    :page.sync="paging.page"
                    :must-sort="true"
                    :disable-pagination="true"
                    hide-default-footer
                    class="tb-monitor-contents"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>
                          <div> <!-- 생성일 -->
                            <span> {{ item.statDay }} </span>
                          </div>
                        </td>
                        <td v-for="column in columnsInfo" :key="column.cdKey" v-show="column.use === 1">
                          <div>
                            <span @click="getExcelDownload(column.cdKey, item)"> {{ item[column.cdValue] }} </span>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template slot="no-data" v-if="objStatList.length == 0">
                      <div class="nodata-txt-noicon">
                        <v-alert :value="true">
                          데이터가 없습니다.
                        </v-alert>
                      </div>
                    </template>
                  </v-data-table>

                  <div v-show="pageCount > 0" class="pagination">
                    <v-pagination
                      v-model="paging.page"
                      circle
                      :length="pageCount"
                      @input="getObjectStatListByDate"
                      :total-visible="7"
                    ></v-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
import AuditSubTab from "./AuditSubTab";
import AuditTab from "./AuditTab";
import SelectBox from "./common/SelectBox";
export default {
  components: {
    Datepicker,
    AuditSubTab,
    AuditTab,
    SelectBox,
  },
  data() {
    return {
      sharUse: localStorage.getItem("sharUse") || "false",
      cfrcUse: localStorage.getItem("cfrcUse") || "false",
      tenantId: localStorage.getItem("tenantId"),
      todo: this.tenantId != "418502" ? "할 일" : "Task",
      workspace: this.tenantId != "418502" ? "과제" : "협업공간",
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      pageCount: 1,
      headers: [{ text: "생성일", value: "selDate", align: "center", value: "statDay", sortable: true  }],
      startDate: new Date(this.$moment().subtract(1, "day")),
      endDate: new Date(this.$moment().subtract(1, "day")),
      startDisabledDate: {
        to: new Date(this.$moment().subtract(90, "days")), // 이후 선택 기간 제한
        from: new Date(this.$moment()), //이전 선택 기간 제한
      },
      endDisabledDate: {
        to: new Date(this.$moment().subtract(90, "days")),
        from: new Date(this.$moment()), //이전 선택 기간 제한
      },
      paging: {
        page: 1,
        perSize: 10,
      },
      sortBy: 'statDay',
      sortDesc: true,
      columnsInfo: null,
      totalCnt: 0,
      objStatList: [],
      sum: null
    };
  },
  created() {
    this.getDataColumnsInfo();
  },
  watch: {
    sortDesc() {
      this.paging.page = 1;
      this.getObjectStatListByDate();
    },
    startDate() {
      if(this.endDate < this.startDate) {
        // alert("시작일이 종료일보다 큽니다. 다시 선택해주세요.");
        // return ;
        this.endDate = this.startDate;
      }
      this.paging.page = 1;
      this.getObjectStatListByDate();
    },
    endDate() {
      if(this.endDate < this.startDate) {
        this.startDate = this.endDate;
      }
      this.paging.page = 1;
      this.getObjectStatListByDate();
    },
    setDisabledDate() {
      this.startDisabledDate.from = new Date(this.$moment().subtract(91, "days"));
      this.endDisabledDate.to = this.$moment();
    },
  },
  methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal"]),
    
    getDataColumnsInfo() {
      let obj = this;
      let reqData = {
        url : "/api/monitor/stat/getDataColumnsInfo",
        method : "post",
        params : {
          item: "object"
        }
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if(res.errorCode != null) {
          console.log(res.errorCode);
        }else{
          let list = res.result;
          list.forEach(item => {
            item.use = 1;
            
            if(obj.sharUse === 'false' && item.cdKey === 'SHAR_CATE_CREATE') item.use = 0;
            if(obj.cfrcUse === 'false' && item.cdKey === 'CFRC_CATE_CREATE') item.use = 0;

            if(item.use == 1) {
              item.text = item.cdKey === 'PRO_CREATE' && obj.tenantId === '418502' ? "협업공간" : item.cdKey === 'TODO_RECEIVE' && obj.tenantId === '418502' ? "Task" : item.codeDesc;
              item.value = item.cdValue;
              item.align = 'center';
              item.sortable = false;
              obj.headers.push(item);
            }
          })
          obj.columnsInfo = list;
          obj.getObjectStatListByDate();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getObjectStatListByDate() {
      this.objStatList = [];
      this.showLoadingbar(); // 프로그레스바 시작

      let obj = this;
      let reqData = {
        url : "/api/monitor/stat/getObjectStatList",
        method : "post",
        params : {
          startDate: obj.$moment(this.startDate).format("YYYY-MM-DD"),
          endDate: obj.$moment(this.endDate).format("YYYY-MM-DD"), // obj.$moment(this.endDate).add(1, "day").format("YYYY-MM-DD"),
          page: obj.paging.page - 1,
          perSize: obj.paging.perSize,
          sortBy: obj.sortBy,
          sortDesc: obj.sortDesc,
          columnsInfo: obj.columnsInfo
        }
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if(res.errorCode != null) {
          console.log(res.errorCode);
        }else{
          let data = res.result;
          obj.sum = data.sum;
          obj.objStatList = data.list;
          obj.totalCnt = data.totalCnt
          obj.pageCount = obj.totalCnt % obj.paging.perSize === 0 ? (obj.totalCnt/obj.paging.perSize) : Math.floor(obj.totalCnt/obj.paging.perSize) + 1;
        }
        obj.hideLoadingbar(); //프로그레스바 종료 
      })
      .catch(function(err) {
        console.log(err);
        obj.hideLoadingbar(); //프로그레스바 종료 
      });
    },
    getExcelDownload(type, item) {
      if(item != null) {
        let cnt = 0;
        if (!type.includes('_ALL')) {
          for(let i=0; i<this.columnsInfo.length; i++) {
            let column = this.columnsInfo[i];
            if (type === column.cdKey) {
              cnt = item[column.cdValue];
              break;
            }
          }
        }else {
          let data = type;
          cnt = item[data.replace('_ALL', '')];
        }
        if(cnt === 0) return false;
      }

        let fileName;
        if(type === 'objectStat') {
          fileName = "메뉴별_활동현황";
        }else if(type.includes('PRO')) {
          fileName = this.workspace + "_활동현황";
        }else if(type.includes('SHAR_CATE')) {
          fileName = "정보카테고리_활동현황";
        }else if(type.includes('CFRC_CATE')) {
          fileName = "회의카테고리_활동현황";
        }else if(type.includes('BOARD')) {
          fileName = "보드_활동현황";
        }else if(type.includes('TODO')) {
          fileName = this.todo + "_활동현황";
        }else if(type.includes('DECISION')) {
          fileName = "의사결정_활동현황";
        }
      
      let param = {
        downloadType: type,
        startDate: this.$moment(this.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.endDate).format("YYYY-MM-DD"),
        statDay: item != null ? item.statDay : null,
        sortBy: this.sortBy,
        sortDesc: type === 'objectStat' ? true : this.sortDesc,
        fileName: fileName,
        headers: this.headers
      }

      this.$axios({
        url : "/api/monitor/stat/downloadExcel",
        responseType: "blob",
        headers: {
            "Content-Type": "application/json"
        },
        method : "post",
        data: param
      }).then(res => {
        let blob = new Blob([res.data], {
          type: res.headers["content-type"]
        });
      
        if(type === 'objectStat' || type.includes('ALL')) {
           fileName += "("+this.$moment(this.startDate).format("YYYY.MM.DD") + "_" + this.$moment(this.endDate).format("YYYY.MM.DD")+")";
        }else{
           fileName += "("+this.$moment(item.statDay).format("YYYY.MM.DD") + ")";
        }

        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName+".xlsx");
        } else {
          let link = document.createElement("a");
          link.target = "_self";
          link.setAttribute("download", fileName+".xlsx");
          link.href = window.URL.createObjectURL(blob);
          link.click();
          link.remove();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    }
  }
};
</script>

<style scoped>
.audit001 {
  margin-top: 38px;
}
.tb-monitor-contents >>> tr {
    /* display: table-row; */
    border-bottom: 1px solid #d9d9d9;
}
.tb-monitor-contents >>> tr td div {
    text-align: center;
}
.tb-monitor-contents >>> tr:hover::before {
    display: none; content: '';
    position: absolute; left: 0; top: -1px;
    width: calc(100%); height: calc(100% + 2px);
    box-shadow: 1px 1.7px 3px 0 rgba(0, 0, 0, 0.15);
    border: solid 1px #000000;
    z-index: 10;
    pointer-events: none;
}
.audit001 >>> input {
  background-color: transparent;
}
.useAll > div.num {
  width: 16%;
}
.partialUse > div.num {
  width: 19%;
}
.notUse > div.num {
  width: 24%;
}


.tb-monitor-contents >>> {
    border-top: 1px solid #d3d4d6;
    border-bottom: 1px solid #d3d4d6;
    background-color: #fff;
}
.tb-list_ty1 .tb-monitor-contents >>> {
    border-top: 0 none;
    border-bottom: 0 none;
}
.tb-monitor-contents.nodata {
    position: relative;
    height: 406px;
}
.tb-monitor-contents >>> td > .nodata-txt {
    padding: 150px 0;
    font-size: 14px; color: #999; text-align:center
}
.tb-monitor-contents.nodata .nodata-txt {
    position: absolute; left: calc(50%); top: calc(50% - 47px);
    height: 94px; padding-top: 79px;
    font-size:14px; color: #999
}
.tb-monitor-contents.nodata .nodata-txt::before,
.tb-monitor-contents.nodata .nodata-txt::after {
    display: block; content: '';
}
.tb-monitor-contents.nodata .nodata-txt::before {
    position: absolute; left: calc(50% - 32px); top:0;
    width: 64px; height: 64px;
    border: solid 1px #d3d4d6; border-radius: 50%;;
}
.tb-monitor-contents >>> {
    width: 100%;
    font-size: 14px;
}
.tb-monitor-contents >>> .thead .th,
.tb-monitor-contents >>> thead th {
    display: table-cell;
    height: 44px; padding: 12px 0px;
    font-size: 12px; color: #999; vertical-align: middle; text-align: center;
}
.tb-monitor-contents >>> .thead .th,
.tb-monitor-contents >>> thead th {border-bottom: 1px solid #d3d4d6}
.tb-monitor-contents >>> .tr:first-child,
.tb-monitor-contents >>> tr:first-child {border-top: 0 none;}
.tb-monitor-contents >>> th span.sort.up {background-position: -70px -221px;}
.tb-monitor-contents >>> th span.sort.dn {
    background-position: -70px -221px;
    transform: rotate(-180deg);
}

.tb-monitor-contents >>> tbody > .tr:hover,
.tb-monitor-contents >>> tbody > tr {position: relative;}
/* .tb-monitor-contents >>> tbody > .tr:hover::before,
.tb-monitor-contents >>> tbody > tr:hover::before {
    display: block; content: '';
    position: absolute; left: 0; top: -1px;
    width: calc(100% - 1px); height: calc(100% + 2px);
    box-shadow: 1px 1.7px 3px 0 rgba(0, 0, 0, 0.15);
    border: solid 1px #000000;
    z-index: 10;
    pointer-events: none;
} */
.tb-monitor-contents.hover-none tbody > .tr:hover::before,
.tb-monitor-contents.hover-none tbody > tr:hover::before {
    display: none;
    width: 0; height: 0;
    box-shadow: none;
    border: 0 none;
}
/* .tb-monitor-contents >>> .tr,
.tb-monitor-contents >>> tr {
    display: table;
    width: 100%;
    border: 1px solid transparent;
    border-top: 1px solid #d3d4d6;
} */
.tb-monitor-contents >>> table,
table.tb-monitor-contents >>> {position: relative;}
.tb-monitor-contents >>> tbody::before,
.tb-monitor-contents >>> tbody::after {
    position: absolute; top: 45px;
    display: block; content: '';
    width: 25px; height: calc(100% - 45px);
    background-color: #fff;
    z-index: 1;
}
.tb-monitor-contents >>> tbody::before {left:0;}
.tb-monitor-contents >>> tbody::after {right:0}
.tb-monitor-contents >>> td .member .name.v-btn {font-size: 12px; color: #999;}
.tb-monitor-contents >>> td .droplayer.member > .v-menu {left: auto !important; right: 0;}
.tb-monitor-contents >>> td .droplayer.member .v-menu__content {
    left: auto !important; right: 0;
    border:0 none;
    box-shadow: none;
}
.tb-monitor-contents >>> td .droplayer.member .tooltip-b.tl::before {left: auto; right: 10px;}
.tb-monitor-contents >>> .td,
.tb-monitor-contents >>> td {
    display: table-cell;
    height: 55px; padding: 12px 0px;
    vertical-align:middle;
}
.tb-monitor-contents >>> tr.disabled td {color: #bbb;}
.tb-monitor-contents >>> .subject {color: #000; cursor: pointer;}
.tb-monitor-contents >>> .subject > .txt + .reason:empty {display: none;}
.tb-monitor-contents >>> .re-de {font-size: 12px;}
.tb-monitor-contents >>> .date {font-size: 12px; color: #999;}
.tb-monitor-contents >>> .re {color: #999}
.tb-monitor-contents >>> .del * {color: #bbb}
.tb-monitor-contents >>> .del .subject .txt,
.tb-monitor-contents >>> .del .subject .re,
.tb-monitor-contents >>> .del .subject .de {text-decoration: line-through;}
.tb-monitor-contents >>> .subject .reason {
    margin-top: 10px;
    font-size: 12px; text-decoration: none;
}
.tb-monitor-contents >>> .division {background-position: -210px -221px;}
.tb-monitor-contents >>> .del .division {background-position: -60px -221px;}

.tb-monitor-contents >>> .request .request {color: #fd7201}
.tb-monitor-contents >>> .fin .fin {color: #a2c10b}
.tb-monitor-contents >>> .date.deadline {color: #fF0000}
.tb-monitor-contents >>> .author {font-size:12px; color:#999;}
.tb-monitor-contents >>> .author .v-btn {font-size:12px; color:#999;}

.tb-monitor-contents >>> tr:last-child .droplayer > .v-menu,
.tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu {top: auto; bottom: 30px}
.tb-monitor-contents >>> tr:last-child .droplayer > .v-menu .v-menu__content,
.tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu .v-menu__content {top: auto !important; bottom: 0}

.ins002a .tb-monitor-contents >>> tr:last-child .droplayer > .v-menu,
.ins002a .tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu {bottom: 29px}
.ins002a .tb-monitor-contents >>> tr:last-child .droplayer > .v-menu .v-menu__content,
.ins002a .tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu .v-menu__content {top: auto !important; bottom: 0}

.bds041 .tb-monitor-contents >>> tr:last-child .droplayer > .v-menu,
.bds041 .tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu {bottom: 20px}
.bds041 .tb-monitor-contents >>> tr:last-child .droplayer > .v-menu .v-menu__content,
.bds041 .tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu .v-menu__content{top: auto !important; bottom: 0}

.tb-monitor-contents >>> tr:last-child .droplayer.tooltipmember > .v-menu,
.tb-monitor-contents >>> tr:nth-last-child(2) .droplayer.tooltipmember > .v-menu {bottom: 17px}
.tb-monitor-contents >>> tr:last-child .droplayer.tooltipmember > .v-menu .v-menu__content,
.tb-monitor-contents >>> tr:nth-last-child(2) .droplayer.tooltipmember > .v-menu .v-menu__content {top: auto !important; bottom: 0}


.tb-monitor-contents >>> tr:first-child .droplayer.tooltipmember > .v-menu {bottom: auto !important;}
.tb-monitor-contents >>> tr:first-child .droplayer.tooltipmember > .v-menu .v-menu__content,
.tb-monitor-contents >>> tr:first-child .droplayer.tooltipmember > .v-menu .v-menu__content {bottom: auto !important; bottom: 0}

.tb-monitor-contents >>> tr:last-child .droplayer > .v-menu .tooltip-b,
.tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu .tooltip-b {margin-top: 0; margin-bottom: 7px}
.tb-monitor-contents >>> tr:last-child .droplayer > .v-menu .tooltip-b::before,
.tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu .tooltip-b::before {
    top:auto; bottom: -7px;
    transform: rotate(180deg);    
}

.tb-monitor-contents >>> tr:last-child:first-child .droplayer > .v-menu {bottom:auto; top: 20px}
.tb-monitor-contents >>> tr:last-child:first-child .droplayer > .v-menu .v-menu__content {bottom:auto; top: 0}
.tb-monitor-contents >>> tr:last-child:first-child .droplayer > .v-menu .tooltip-b {margin-top: 7px; margin-bottom: 0}
.tb-monitor-contents >>> tr:last-child:first-child .droplayer > .v-menu .tooltip-b::before {
    top: -7px; bottom: auto;
    transform: rotate(0);    
}

.tb-monitor-contents >>> tr:first-child .droplayer > .v-menu {bottom:auto; top: 20px}
.tb-monitor-contents >>> tr:first-child .droplayer > .v-menu .v-menu__content {bottom:auto; top: 0}
.tb-monitor-contents >>> tr:first-child .droplayer > .v-menu .tooltip-b {margin-top: 7px; margin-bottom: 0}
.tb-monitor-contents >>> tr:first-child .droplayer > .v-menu .tooltip-b::before {
    top: -7px; bottom: auto;
    transform: rotate(0);    
}


.tb-monitor-contents >>> tr.v-data-table__empty-wrapper td {width: 100% !important; height: 376px !important; padding: 0}
.tb-monitor-contents >>> tr.v-data-table__empty-wrapper:hover::before {
    content: inherit;
    width:0; height: 0; border-color: transparent;
}


</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/MonitorObjectStat.vue